import { Component, OnInit } from '@angular/core';
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery";
import { MapService } from "../../view/services/map.service";
import Basemap from "@arcgis/core/Basemap";



@Component({
  selector: 'app-basemap-gallery',
  templateUrl: './basemap-gallery.component.html',
  styleUrls: ['./basemap-gallery.component.css']
})
export class BasemapGalleryComponent implements OnInit {
  basemapGallery: BasemapGallery;
  constructor(public mapService: MapService) { }

  ngOnInit(): void {
    let basemapCCH = new Basemap({
      portalItem: {
        id: "11dd85011fab42e18f656c43144396f2"  //BaseMap Huila Imagenes Satelitales + Imagery Google
      }
    });
    this.basemapGallery = new BasemapGallery({
      view: this.mapService.getViewMap(),
      container: 'divBasemapGallery'
    });
  }

}
